import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const emailContactInfo = createAsyncThunk(
  'email/contactInfo',
  async (
    { firstName, lastName, preference, email, phoneNumber, address, description, recaptchaToken, website },
    thunkAPI
  ) => {
    try {
      const response = await axios.post('/api/email/ContactInfo', {
        firstName,
        lastName,
        preference,
        email,
        phoneNumber,
        address,
        description,
        recaptchaToken,
        website,
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const addToNewsletter = createAsyncThunk(
  'email/addToNewsletter',
  async (email, thunkAPI) => {
    try {
      const response = await axios.post('/api/email/addToNewsletter', { email });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const emailSlice = createSlice({
  name: 'email',
  initialState: {
    contactInfo: {
      loading: false,
      success: false,
      info: null,
      error: null,
    },
    newsletter: {
      loading: false,
      success: false,
      data: null,
      error: null,
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Contact Info
      .addCase(emailContactInfo.pending, (state) => {
        state.contactInfo = { loading: true, success: false, info: null, error: null };
      })
      .addCase(emailContactInfo.fulfilled, (state, action) => {
        state.contactInfo = { loading: false, success: true, info: action.payload, error: null };
      })
      .addCase(emailContactInfo.rejected, (state, action) => {
        state.contactInfo = { loading: false, success: false, info: null, error: action.payload };
      })

      // Newsletter
      .addCase(addToNewsletter.pending, (state) => {
        state.newsletter = { loading: true, success: false, data: null, error: null };
      })
      .addCase(addToNewsletter.fulfilled, (state, action) => {
        state.newsletter = { loading: false, success: true, data: action.payload, error: null };
      })
      .addCase(addToNewsletter.rejected, (state, action) => {
        state.newsletter = { loading: false, success: false, data: null, error: action.payload };
      });
  },
});

export default emailSlice.reducer;
